module.exports = __webpack_public_path__ + "img/play-button-desktop-color.324f39ba15e226ac8f118afd3c8bdb72.svg";